import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function FranchisePackModule() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/franchise-pack");
      setData(data);
    })();
  }, []);

  if (!data) return <div className="p-6 text-zinc-400">Chargement…</div>;

  return (
    <div className="space-y-6 p-6 max-w-6xl mx-auto" data-testid="franchise-pack-module">
      <div>
        <h1 className="text-3xl font-bold text-amber-400 tracking-tight">
          🌐 Franchise Pack Kaizen — Roadmap & Vision
        </h1>
        <p className="text-zinc-400 text-sm mt-1">
          Le « McDonald's du tatami » · Roadmap 24 mois · Démarches légales QC/CA · Contacts à voir
        </p>
      </div>

      {/* VISION */}
      <section className="bg-gradient-to-br from-amber-500/10 to-emerald-500/10 border border-amber-500/30 rounded-xl p-6">
        <div className="text-xs uppercase text-amber-400 tracking-widest">Tagline</div>
        <div className="text-xl font-bold text-zinc-100 mt-1">{data.vision.tagline}</div>
        <div className="mt-4 text-sm text-zinc-300">
          <div className="text-xs uppercase text-zinc-500">Mission</div>
          <p className="mt-1">{data.vision.mission}</p>
        </div>
        <div className="grid md:grid-cols-2 gap-4 mt-4">
          <div className="bg-zinc-950 border border-zinc-800 rounded p-3 text-sm text-zinc-300">
            <div className="text-xs uppercase text-emerald-400">Vision 3-5 ans</div>
            <p className="mt-1">{data.vision.vision_3_5_ans}</p>
          </div>
          <div className="bg-zinc-950 border border-zinc-800 rounded p-3 text-sm text-zinc-300">
            <div className="text-xs uppercase text-amber-400">Vision 10 ans</div>
            <p className="mt-1">{data.vision.vision_10_ans}</p>
          </div>
        </div>
      </section>

      {/* ELEVATOR PITCH */}
      <section className="bg-zinc-900 border-2 border-amber-500/40 rounded-xl p-5">
        <h2 className="text-lg font-bold text-amber-300 mb-2">🎤 Elevator pitch 30 secondes</h2>
        <p className="text-zinc-200 italic leading-relaxed">"{data.elevator_pitch_30s}"</p>
      </section>

      {/* MODULES */}
      <div className="grid md:grid-cols-2 gap-5">
        <section>
          <h2 className="text-lg font-bold text-emerald-300 mb-3">✅ Modules obligatoires ({data.modules_obligatoires.length})</h2>
          <div className="space-y-2">
            {data.modules_obligatoires.map((m, i) => (
              <div key={i} className="bg-zinc-900 border border-emerald-500/30 rounded p-3" data-testid={`module-oblig-${i}`}>
                <div className="font-semibold text-zinc-100 text-sm">{m.name}</div>
                <div className="text-xs text-zinc-400 mt-1">{m.desc}</div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="text-lg font-bold text-blue-300 mb-3">⭐ Modules optionnels ({data.modules_optionnels.length})</h2>
          <div className="space-y-2">
            {data.modules_optionnels.map((m, i) => (
              <div key={i} className="bg-zinc-900 border border-blue-500/30 rounded p-3" data-testid={`module-opt-${i}`}>
                <div className="font-semibold text-zinc-100 text-sm">{m.name}</div>
                <div className="text-xs text-zinc-400 mt-1">{m.desc}</div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* REDEVANCES */}
      <section className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
        <h2 className="text-lg font-bold text-amber-300 mb-3">💰 Redevances (à valider avec avocat)</h2>
        <div className="grid md:grid-cols-2 gap-2 text-sm">
          {Object.entries(data.redevances).map(([k, v]) => (
            <div key={k} className="bg-zinc-950 border border-zinc-800 rounded p-3 flex justify-between">
              <span className="text-zinc-400 capitalize">{k.replace(/_/g, " ")}</span>
              <span className="font-semibold text-amber-300">{v}</span>
            </div>
          ))}
        </div>
      </section>

      {/* DÉMARCHES LÉGALES */}
      <section className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
        <h2 className="text-lg font-bold text-amber-300 mb-3">⚖️ Démarches légales QC/CA (étapes)</h2>
        <ol className="space-y-2">
          {data.demarches_legales_qc_ca.map((d) => (
            <li key={d.step} className="bg-zinc-950 border border-zinc-800 rounded p-3" data-testid={`demarche-${d.step}`}>
              <div className="flex items-start gap-3">
                <div className="text-amber-300 font-bold text-lg">{d.step}.</div>
                <div className="flex-1">
                  <div className="font-semibold text-zinc-100">{d.name}</div>
                  <div className="text-sm text-zinc-400 mt-1">{d.action}</div>
                  {d.url && (
                    <a href={d.url} target="_blank" rel="noreferrer" className="text-xs text-amber-400 hover:underline">
                      🔗 {d.url}
                    </a>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </section>

      {/* CONTACTS */}
      <section className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
        <h2 className="text-lg font-bold text-amber-300 mb-3">📞 Contacts à voir ({data.contacts_a_voir.length})</h2>
        <div className="grid md:grid-cols-2 gap-2">
          {data.contacts_a_voir.map((c, i) => (
            <div key={i} className="bg-zinc-950 border border-zinc-800 rounded p-3" data-testid={`contact-${i}`}>
              <div className="flex justify-between items-start">
                <div className="font-semibold text-zinc-100 text-sm">{c.name}</div>
                <span className={`text-[10px] px-2 py-0.5 rounded ${
                  c.priority === "P0" ? "bg-rose-500/20 text-rose-300" : c.priority === "P1" ? "bg-amber-500/20 text-amber-300" : "bg-zinc-700 text-zinc-300"
                }`}>{c.priority}</span>
              </div>
              <div className="text-xs text-zinc-400 mt-1">{c.raison}</div>
              {c.url && (
                <a href={c.url} target="_blank" rel="noreferrer" className="text-xs text-amber-400 hover:underline">
                  🔗 {c.url}
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ROADMAP */}
      <section className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
        <h2 className="text-lg font-bold text-amber-300 mb-3">🗺️ Roadmap 24 mois</h2>
        <div className="space-y-4">
          {data.roadmap_24_mois.map((r, i) => (
            <div key={i} className="border-l-4 border-amber-500 pl-4" data-testid={`roadmap-${i}`}>
              <div className="text-amber-300 font-bold">{r.phase}</div>
              <ul className="mt-1 space-y-0.5">
                {r.actions.map((a, j) => (
                  <li key={j} className="text-sm text-zinc-300">• {a}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
